// extracted by mini-css-extract-plugin
export default {"button":"N5vaSN","icon":"Uafo5z","text":"gJpAyV","withText":"hmoJtb"};